/* Lightweight countdown timer - theme-native replacement for the countdown app.
   Modes: daily (resets each day), date (fixed end), evergreen (per-visitor minutes). */
(function () {
  'use strict';
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function computeTarget(el) {
    var now = new Date();
    var mode = el.getAttribute('data-mode');
    if (mode === 'date') {
      var end = el.getAttribute('data-end') || '';
      var t = new Date(end.replace(' ', 'T'));
      return isNaN(t.getTime()) ? now : t;
    }
    if (mode === 'evergreen') {
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15;
      var key = 'cdt_' + el.getAttribute('data-uid');
      var stored = parseInt(localStorage.getItem(key), 10);
      if (!stored || isNaN(stored)) {
        stored = now.getTime() + mins * 60000;
        try { localStorage.setItem(key, stored); } catch (e) {}
      }
      return new Date(stored);
    }
    var h = parseInt(el.getAttribute('data-hour'), 10) || 0;
    var m = parseInt(el.getAttribute('data-min'), 10) || 0;
    var d = new Date(now);
    d.setHours(h, m, 0, 0);
    if (d <= now) d.setDate(d.getDate() + 1);
    return d;
  }
  function setDigits(el, days, h, m, s) {
    if (el.getAttribute('data-show-days') !== '1') { h = h + days * 24; days = 0; }
    var d = el.querySelector('.cdt__d'), H = el.querySelector('.cdt__h'),
        M = el.querySelector('.cdt__m'), S = el.querySelector('.cdt__s');
    if (d) d.textContent = pad(days);
    if (H) H.textContent = pad(h);
    if (M) M.textContent = pad(m);
    if (S) S.textContent = pad(s);
  }
  function init(el) {
    if (el.__cdt) return; el.__cdt = true;
    var mode = el.getAttribute('data-mode');
    var target = computeTarget(el);
    var iv;
    function tick() {
      var diff = Math.floor((target - new Date()) / 1000);
      if (diff <= 0) {
        if (mode === 'daily') {
          target = computeTarget(el);
          diff = Math.floor((target - new Date()) / 1000);
        } else {
          if ((el.getAttribute('data-expire') || 'hide') === 'hide') { el.style.display = 'none'; }
          else { setDigits(el, 0, 0, 0, 0); }
          clearInterval(iv);
          return;
        }
      }
      setDigits(el,
        Math.floor(diff / 86400),
        Math.floor((diff % 86400) / 3600),
        Math.floor((diff % 3600) / 60),
        diff % 60);
    }
    tick();
    iv = setInterval(tick, 1000);
  }
  function boot() {
    var els = document.querySelectorAll('.cdt[data-mode]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
